var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.271,55.532c-.082-.042-1.847-.957-4.893-1.8v-2.504c0-.461-.233-.891-.62-1.145-.151-.1-15.353-9.704-33.758,5.54-18.421-15.244-33.606-5.638-33.761-5.539-.386,.253-.618,.683-.618,1.144v2.503c-3.058,.844-4.815,1.76-4.896,1.802-.447,.238-.726,.701-.726,1.208v44.207c0,.406,.181,.792,.492,1.052,.312,.26,.723,.368,1.123,.294,.2-.037,20.149-3.626,37.706,.58,.045,.011,.092,.019,.138,.026,.052,.007,.104,.022,.149,.034,.125,.038,.252,.055,.376,.056l.015,.002,.015-.002c.125-.001,.252-.018,.376-.056,.042-.012,.085-.029,.134-.034,.046-.005,.093-.015,.138-.026,17.538-4.2,37.523-.615,37.723-.58,.399,.073,.81-.034,1.123-.294,.312-.26,.492-.645,.492-1.052V56.742c.001-.508-.28-.974-.729-1.211h0ZM37.734,99.339V57.614c.607-.261,1.596-.647,2.887-1.035v34.742c0,.375,.154,.734,.427,.991,.272,.258,.639,.394,1.013,.374,.149-.01,14.232-.636,27.842,6.531-13.812-2.248-27.537-.579-32.17,.123h0Zm35.899-1.15c-12.597-7.557-25.926-8.261-30.275-8.266V52.016c2.877-1.545,15.135-6.779,30.275,6.024v40.151Zm2.735-40.152c15.134-12.807,27.404-7.566,30.275-6.024v37.91c-4.352,.004-17.683,.708-30.275,8.256V58.039Zm35.899,41.3c-4.633-.705-18.369-2.373-32.184-.123,13.612-7.167,27.698-6.54,27.858-6.531,.365,.018,.74-.115,1.012-.374,.272-.258,.427-.617,.427-.991V56.58c1.286,.39,2.278,.774,2.887,1.035v41.724h0Z",
    fill: "#47d5cd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBk);
export default __webpack_public_path__ + "static/media/bk.9f497231d15ffa96dad0261a0dc895c4.svg";
export { ForwardRef as ReactComponent };